import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { withStyles, withTheme } from '@material-ui/core/styles';
import { TextValidator } from 'react-material-ui-form-validator';

// import PhoneValidator from './PhoneValidator'
import ConditionalSentiment from './ConditionalSentiment'
import CONSTANTS from '../utils/Constants';

const styles = theme => ({
	bottomBar: {
		top: 'auto',
		bottom: 0,
	},
	form: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	positive: {
		backgroundColor: CONSTANTS.COLORS.POSITIVE,
	},
	uncertain: {
		backgroundColor: CONSTANTS.COLORS.UNCERTAIN,
	},
	negative: {
		backgroundColor: CONSTANTS.COLORS.NEGATIVE,
	},
	bottomBackground: {
		backgroundColor: theme.palette.background.default,
	},
	gutters: {
		marginTop: (2 * theme.spacing.unit),
		paddingLeft: (theme.spacing.unit * 3.5),
		paddingRight: (theme.spacing.unit * 3.5)
	},
	grow: {
		flex: 1
	},
	rightBtn: {
		marginRight: -1 * theme.spacing.unit
	},

	attachBtn: {
		// borderColor: theme.palette.action.active,
		borderWidth: 1,
		borderStyle: "solid",
		fontSize: "1.6rem",
		width: 5.25 * theme.spacing.unit,
		height: 5.25 * theme.spacing.unit,
	},
	attachIcon: {
		color: theme.palette.action.active,
	},
	fieldsHidden: {
		// transition: 'width 0.75s ease-in, opacity 0.74s cubic-bezier(0.95, 0.05, 0.795, 0.035), height 0.74s cubic-bezier(0.95, 0.05, 0.795, 0.035)',
		// height: 0,
		transition: 'width 0.75s ease-in, opacity 0.74s cubic-bezier(0.95, 0.05, 0.795, 0.035)',
		width: 0,
		opacity: 0
	},
	fieldsVisible: {
		// transition: 'width 0.75s cubic-bezier(0.000, 0.795, 0.000, 1.000), opacity 0.3s ease-out, height 0.2s linear',
		// height: "auto",
		transition: 'width 0.75s cubic-bezier(0.000, 0.795, 0.000, 1.000), opacity 0.3s ease-out',
		width: "100%",
		opacity: 1
	},
	emailConf: {
		// /* https://snook.ca/archives/html_and_css/hiding-content-for-accessibility */
		position: "absolute !important",
		height: "1px" ,
		width: "1px",
		overflow: "hidden",
		clip: "rect(1px, 1px, 1px, 1px)"
	},
	secondaryFields: {
		marginTop: 2 * theme.spacing.unit,
	}
});

class SubmissionForm extends Component {
	render() {
		let {classes, identify, identifyName, identifyEmail, identifyPhone, identifyHandler, showConcernOther, concernOther, fieldChangeHandler, concernOtherHandler, concernOtherDescription, sentimentProps, description, identifyEmailConf, descriptionLabel, placeholder} = this.props;
		let spacing = 2 * this.props.theme.spacing.unit;

		return (
			<div className={classes.gutters}>
				<Grid container direction="column" alignItems="stretch" spacing={spacing}>
					<Grid item>
						<ConditionalSentiment {...sentimentProps} />
					</Grid>
					<Grid item>
						<Typography variant="subtitle1">{descriptionLabel}</Typography>
						<TextField multiline fullWidth
							id="description"
							name="description"
							aria-label={descriptionLabel}
							value={description}
							rows="4"
							placeholder={placeholder}
							onChange={fieldChangeHandler}
							margin="none"
							variant="outlined"
						/>
					</Grid>
					<Grid item>
						<FormControlLabel
							control={
								<Checkbox
									value="identify"
									aria-label="Identify yourself?"
									checked={identify}
									color="primary"
									onChange={identifyHandler}
								/>
							}
							label="Would you like to identify yourself?"
						/>
						<Collapse in={identify} timeout={850} className={classes.secondaryFields}>
							<Grid container direction="column" alignItems="stretch" spacing={spacing}>
								<Grid item>
									<TextField fullWidth
										id="identifyName"
										name="identifyName"
										aria-label="Name"
										label="Name"
										placeholder="First & Last Name"
										margin="none"
										variant="outlined"
										value={identifyName}
										onChange={fieldChangeHandler}
										className={identify ? classes.fieldsVisible : classes.fieldsHidden}
									/>
								</Grid>
								<Grid item>
									<TextField fullWidth
										id="identifyPhone"
										name="identifyPhone"
										label="Phone"
										aria-label="Phone"
										placeholder=""
										margin="none"
										variant="outlined"
										value={identifyPhone}
										onChange={fieldChangeHandler}
										className={identify ? classes.fieldsVisible : classes.fieldsHidden}
									/>
								</Grid>
								<Grid item>
									<TextValidator
										label="Email"
										name="identifyEmail"
										aria-label="Email"
										placeholder=""
										margin="none"
										variant="outlined"
										value={identifyEmail}
										onChange={fieldChangeHandler}
										className={identify ? classes.fieldsVisible : classes.fieldsHidden}

										validators={['isEmail']}
										errorMessages={['email is not valid']}
									/>
									<TextField fullWidth
										id="identifyEmailConf"
										name="identifyEmailConf"
										label="Confirm Address"
										aria-label="Confirm Address"
										aria-hidden="true"
										placeholder=""
										inputProps={{
											tabIndex: "-1",
											autoComplete: "false"
										}}
										margin="none"
										variant="outlined"
										value={identifyEmailConf}
										onChange={fieldChangeHandler}
										className={`${classes.emailConf} ${classes.fieldsHidden}`}
									/>
								</Grid>
							</Grid>
						</Collapse>
					</Grid>
					{showConcernOther ?
					<Grid item>
						<FormControlLabel
							control={
								<Checkbox
									value="concernOther"
									aria-label="Concerned for someone else?"
									checked={concernOther}
									color="primary"
									onChange={concernOtherHandler}
								/>
							}
							label="Are you concerned for someone other than yourself?"
						/>
						<Collapse in={concernOther} timeout={850} className={classes.secondaryFields}>
							<Grid container direction="column" alignItems="stretch" spacing={spacing}>
								<Grid item>
									<Typography 
										variant="subtitle1"
										className={concernOther ? classes.fieldsVisible : classes.fieldsHidden}
									>Who? Why?</Typography>
									<TextField fullWidth multiline
										id="concernOtherDescription"
										name="concernOtherDescription"
										aria-label="Name or description"
										rows="4"
										placeholder="Please describe as thoroughly as you can, names, nicknames, friends, which school they attend, etc. Anything helpful."
										margin="none"
										variant="outlined"
										onChange={fieldChangeHandler}
										value={concernOtherDescription}
										className={concernOther ? classes.fieldsVisible : classes.fieldsHidden}
									/>
								</Grid>
							</Grid>
						</Collapse>
					</Grid>
					: null}
				</Grid>
			</div>
		);
	}
}

/*<PhoneValidator fullWidth
	id="identifyPhone"
	name="identifyPhone"
	label="Phone"
	aria-label="Phone"
	placeholder=""
	margin="none"
	variant="outlined"
	value={identifyPhone}
	validators={['matchRegexp:^\\(?[1-9][0-9][0-9]\\)? ?[1-9][0-9][0-9]-?[0-9][0-9][0-9][0-9]$', 'isValidNumber']}
	errorMessages={['must be a complete, valid phone number', 'must be a complete, valid phone number']}
	onChange={fieldChangeHandler}
	className={identify ? classes.fieldsVisible : classes.fieldsHidden}
/>*/
SubmissionForm.propTypes = {
	classes: PropTypes.object.isRequired,
	showConcernOther: PropTypes.bool,
	sentimentProps: PropTypes.object.isRequired,

	identifyHandler: PropTypes.func.isRequired,
	fieldChangeHandler: PropTypes.func.isRequired,

	placeholder: PropTypes.string.isRequired,
	descriptionLabel: PropTypes.string.isRequired,

	identify: PropTypes.bool,
	identifyName: PropTypes.string.isRequired,
	identifyEmail: PropTypes.string.isRequired,
	identifyPhone: PropTypes.string.isRequired,
	identifyEmailConf: PropTypes.string.isRequired,
	concernOther: PropTypes.bool,
	description: PropTypes.string.isRequired
};

export default withStyles(styles)(withTheme()(SubmissionForm));
